import RingSearch from '../../src/legacy/RingSearch';
export default RingSearch;
